import { authHeader, handleResponse } from './helpers';

const API_BASE_URL = process.env.REACT_APP_API_ADDRESS;

/**
 * List contacts (scoped by tenant on backend unless superuser).
 * GET /tenants/tenant-contacts/?search=...&type=management
 */
export const listTenantContacts = async (params = {}) => {
  const url = new URL(`${API_BASE_URL}/tenants/tenant-contacts/`);
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') url.searchParams.append(k, v);
  });
  const res = await fetch(url, { headers: { ...authHeader() } });
  return handleResponse(res, 'Failed to fetch contacts');
};

/**
 * Retrieve one contact
 */
export const getTenantContact = async (id) => {
  const url = `${API_BASE_URL}/tenants/tenant-contacts/${id}/`;
  const res = await fetch(url, { headers: { ...authHeader() } });
  return handleResponse(res, 'Failed to fetch contact');
};

/**
 * Create a contact
 */
export const createTenantContact = async (data) => {
  const url = `${API_BASE_URL}/tenants/tenant-contacts/`;
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify(data),
  });
  return handleResponse(res, 'Failed to create contact');
};

/**
 * Update a contact
 */
export const updateTenantContact = async (id, data) => {
  const url = `${API_BASE_URL}/tenants/tenant-contacts/${id}/`;
  const res = await fetch(url, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify(data),
  });
  return handleResponse(res, 'Failed to update contact');
};

/**
 * Delete a contact
 */
export const deleteTenantContact = async (id) => {
  const url = `${API_BASE_URL}/tenants/tenant-contacts/${id}/`;
  const res = await fetch(url, {
    method: 'DELETE',
    headers: { ...authHeader() },
  });
  return handleResponse(res, 'Failed to delete contact');
};

/**
 * Optional: bulk upsert
 */
export const bulkUpsertTenantContacts = async (contacts) => {
  const url = `${API_BASE_URL}/tenants/tenant-contacts/bulk_upsert/`;
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify({ contacts }),
  });
  return handleResponse(res, 'Failed to bulk upsert contacts');
};
